//vuex数据仓库
import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import persistedState from 'vuex-persistedstate';

//注册插件
Vue.use(Vuex);

//动态导入store模块
const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
    const value = modulesFiles(modulePath);
    modules[moduleName] = value.default;
    return modules;
}, {});

//创建并导出仓库实例
export default new Vuex.Store({
    getters,
    modules,
    plugins: [persistedState()]
});